
@if (order() && order()?.orderId && order()?.stateId==1) {
     <p-button [disabled]="disabled()" severity="primary"  label="Richiedi Preventivo" (click)="run('INIZIA_PREVENTIVO', order()!.orderId!)"/> 
}
@if (order() && order()?.orderId && order()?.stateId==2) {
     <p-button [disabled]="disabled()" severity="primary"  label="Archivia" (click)="run('ARCHIVIA', order()!.orderId!)"/> 
}
@if (order() && order()?.orderId && order()?.stateId==3) {
     <p-button [disabled]="disabled()" severity="primary"  label="Riapri" (click)="run('RIAPRI', order()!.orderId!)"/> 
}

<div class="flex justify-between">
      @if(positionWorkflowSubState() && positionWorkflowSubState()!.actions){
            <div class="mr-2">
                  <ng-content></ng-content>
            </div>
            <div class="mr-2">
            @if(positionWorkflowSubState()!.actions!.prev){
                  <p-button [disabled]="disabled()" severity="warn" [label]="positionWorkflowSubState()!.actions!.prev!.label!" (click)="run(positionWorkflowSubState()!.actions!.prev!.code!, position()!.positionId!)"/>
            }
            </div>
            <div>

            @if(positionWorkflowSubState()!.actions!.next){
                  <p-button [disabled]="disabled()" severity="primary" [label]="positionWorkflowSubState()!.actions!.next!.label!" (click)="run(positionWorkflowSubState()!.actions!.next!.code!, position()!.positionId!)"/>
            }
            </div>
      }
</div>